import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ClaimGeneralDataModel } from '../../models';
import { ClaimDetailConstant } from '../../models/claim-detail-constants';

@Component({
  selector: 'ds-claim-status-general',
  templateUrl: './claim-status-general.component.html',
  styleUrls: ['../../containers/auto-claim-status/auto-claim-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ClaimStatusGeneralComponent {
  @Input() claimGeneralData: ClaimGeneralDataModel;
  @Input() hasGeneralData: boolean;
  @Input() claimType: string;

  claimDetailConstant = ClaimDetailConstant;

  constructor() {}
}
